import { useNode } from "@craftjs/core";
import * as React from "react";
import { useTranslation } from "react-i18next";

import ImagePositioner from "@/components/editor/image-positioner/image-positioner-component";
import ImageUpload from "@/components/editor/image-upload/image-upload-component";
import SettingsTitleWrapper from "@/components/editor/shared/settings-title-wrapper";

export default function ImageSettings() {
  const {
    props,
    actions: { setProp },
    nodeId,
  } = useNode((node) => {
    return {
      nodeId: node.id,
      props: node.data.props,
    };
  });

  const { t } = useTranslation();

  const handlePictureFrameChange = React.useCallback(
    (event) => {
      const { value } = event.target;
      setProp((props) => (props.shape = value));
    },
    [setProp]
  );

  return (
    <SettingsTitleWrapper title={t("preference-panel.image")}>
      <div className="grid gap-2">
        <ImageUpload
          blockType={props.blockType}
          nodeId={nodeId}
          imagePropName="imageUrl"
          imageWidth="200"
          imageHeight="200"
          imageCornerRadius={props.shape === "circle" ? "round" : "md"}
        />
        <p className="text-sm leading-6 text-gray-600 ">
          {t("preference-panel.please-use-formats")}
        </p>
      </div>
      <fieldset
        className="mb-3 mt-4"
        data-testid="paragraph-picture-shape-settings"
      >
        <legend className="mb-2 text-sm font-medium text-gray-700">
          {t("preference-panel.shape")}
        </legend>
        <div className="flex gap-4">
          <label className="flex cursor-pointer items-center gap-2">
            <input
              type="radio"
              id="circle-shape"
              name="picture-frame"
              value="circle"
              checked={props.shape === "circle"}
              onChange={handlePictureFrameChange}
              className="size-4 border-gray-300 text-blue-500 focus:ring-blue-500"
            />
            <span className="text-sm text-gray-700">
              {t("preference-panel.circle")}
            </span>
          </label>
          <label className="flex cursor-pointer items-center gap-2">
            <input
              type="radio"
              id="rectangle-shape"
              name="picture-frame"
              value="rectangle"
              checked={props.shape === "rectangle"}
              onChange={handlePictureFrameChange}
              className="size-4 border-gray-300 text-blue-500 focus:ring-blue-500"
            />
            <span className="text-sm text-gray-700">
              {t("preference-panel.square")}
            </span>
          </label>
        </div>
      </fieldset>
      <h2 className="mb-4 text-sm font-normal leading-6">
        {t("preference-panel.image-position")}
      </h2>
      <ImagePositioner nodeId={nodeId} imagePropName="objectPosition" />
    </SettingsTitleWrapper>
  );
}
